import { createContext } from 'react'

/**
 * De definitie van het openbare registratieformulier, zoals getPublicEventForm
 * die teruggeeft (functions/events/getPublicEventForm.js). Staat er een waarde
 * in, dan lezen MultipleOptionsField en SubTargetgroupsEvents hieruit in plaats
 * van uit Firestore. Elders (AddEvent, ingelogd) is de waarde null en lezen ze
 * zoals altijd.
 *
 * @typedef {object} PublicEventFormData
 * @property {Array<object>} forms
 * @property {Array<object>} fields - Op Position, zonder verwijderde
 * @property {Array<object>} activities
 * @property {Array<object>} outputs - Op Position
 * @property {Array<object>} targetgroups - In de volgorde van de activiteit
 * @property {Object<string, Array<object>>} subTargetgroups - Per doelgroep-id
 * @property {Object<string, Array<object>>} options - Per veld-id
 */

/** @type {import('react').Context<PublicEventFormData|null>} */
const PublicEventFormContext = createContext(null)

export default PublicEventFormContext
